import { TCropArea } from '../types/TCropArea';

type TCropOutputRect = {
  source: TCropArea;
  size: number;
};

const clamp = (value: number, min: number, max: number) => Math.min(Math.max(value, min), max);

export function getCropOutputRect(
  area: TCropArea,
  imageWidth: number,
  imageHeight: number,
  maxSize: number,
): TCropOutputRect {
  const x = clamp(Math.round(area.x), 0, Math.max(imageWidth - 1, 0));
  const y = clamp(Math.round(area.y), 0, Math.max(imageHeight - 1, 0));
  const width = clamp(Math.round(area.width), 1, imageWidth - x);
  const height = clamp(Math.round(area.height), 1, imageHeight - y);
  const size = Math.max(Math.min(maxSize, width, height), 1);

  return { source: { x, y, width, height }, size };
}
